import { YeshivaEnums } from 'src/serverTypes/yeshivaTypesEnums';
//import { AngularApp} from '../serverTypes/yeshivaTypes'

//TODO: change to enums
//TODO: add orderby,category,search,order
export class LessonsFilter {
    public catId: number | null = null;
    //true => include also those lessons (if false - don't use it for filter)
    //two values with true => OR operation
    public filtVideo: Boolean = false;
    public filtAudio: Boolean = false;
    public filtTxt: Boolean = false;
    //not in use foe now
    public filtPDF: Boolean = false;
    public filtDoc: Boolean = false;

    public filtMinLength: number | undefined;
    public filtMaxLength: number | undefined;

    public filtRabbis: number[] = [];

    public orderBy: YeshivaEnums.AngularApp.API.enums.OrderBy | null = null;
    public order: YeshivaEnums.AngularApp.API.enums.Order | null = null;

    public page: number | null = null;
    //public lessonsLength: YeshivaEnums.AngularApp.API.enums.LessonsLengths = null;
    //public lessonsDates: YeshivaEnums.AngularApp.API.enums.LessonsLDates = null;

    public searchTerm: string | null = null;
    homepageFirstPage: boolean = false;

    public filtWomanLesson: boolean = false;
    public filtChildLesson: boolean = false;
    public filtGeneralLesson: boolean = true;

    public validForFilter(lesson: any): boolean {
        var valid: boolean = true;
        //TODO: add lessons parameters and check according to filter

        return valid;
    }

    public updateNedeed(otherFilter: LessonsFilter, fixedFilter: LessonsFilter | null = null): boolean {
        if (this.filtVideo != otherFilter.filtVideo && (!fixedFilter || fixedFilter.filtVideo !== true)) {
            return true;
        }
        if (this.filtAudio != otherFilter.filtAudio && (!fixedFilter || fixedFilter.filtAudio != true)) {
            return true;
        }
        if (this.filtTxt !== otherFilter.filtTxt && (!fixedFilter || fixedFilter.filtTxt != true)) {
            return true;
        }
        if (this.filtPDF !== otherFilter.filtPDF && (!fixedFilter || fixedFilter.filtPDF != true)) {
            return true;
        }
        if (this.filtDoc != otherFilter.filtDoc && (!fixedFilter || fixedFilter.filtDoc != true)) {
            return true;
        }
        if (this.catId != otherFilter.catId && (!fixedFilter || fixedFilter.catId == null)) {
            return true;
        }
        if (!this.isEqualArreys(this.filtRabbis, otherFilter.filtRabbis) && (!fixedFilter || fixedFilter.filtRabbis.length === 0)) {
            return true;
        }
        if (this.orderBy != otherFilter.orderBy && (!fixedFilter || fixedFilter.orderBy == null)) {
            return true;
        }
        if (this.order != otherFilter.order && (!fixedFilter || fixedFilter.order == null)) {
            return true;
        }
        if (this.searchTerm != otherFilter.searchTerm && (!fixedFilter || fixedFilter.searchTerm == null)) {
            return true;
        }
        if (this.filtMinLength != otherFilter.filtMinLength && (!fixedFilter || fixedFilter.filtMinLength == undefined)) {
            return true;
        }
        if (this.filtMaxLength != otherFilter.filtMaxLength && (!fixedFilter || fixedFilter.filtMaxLength == undefined)) {
            return true;
        }
        if (this.filtWomanLesson != otherFilter.filtWomanLesson && (!fixedFilter || fixedFilter.filtWomanLesson !== true)) {
            return true;
        }
        if (this.filtChildLesson != otherFilter.filtChildLesson && (!fixedFilter || fixedFilter.filtChildLesson !== true)) {
            return true;
        }
        if (this.filtGeneralLesson != otherFilter.filtGeneralLesson || !fixedFilter || fixedFilter.filtGeneralLesson !== true) {
            return true;
        }
        return false;
    }

    //combine fixed filter with general filter
    public combaineFixedFilterWithGeneralFilter(generalFilter: LessonsFilter): LessonsFilter {
        let combainedFilter: LessonsFilter = new LessonsFilter();
        combainedFilter.filtVideo = this.filtVideo || generalFilter.filtVideo;
        combainedFilter.filtAudio = this.filtAudio || generalFilter.filtAudio;
        combainedFilter.filtTxt = this.filtTxt || generalFilter.filtTxt;
        combainedFilter.filtPDF = this.filtPDF || generalFilter.filtPDF;
        combainedFilter.filtDoc = this.filtDoc || generalFilter.filtDoc;
        combainedFilter.filtChildLesson = this.filtChildLesson || generalFilter.filtChildLesson;
        combainedFilter.filtGeneralLesson = this.filtGeneralLesson && generalFilter.filtGeneralLesson;
        combainedFilter.filtWomanLesson = this.filtWomanLesson || generalFilter.filtWomanLesson;
        combainedFilter.catId = this.catId != null ? this.catId : generalFilter.catId;
        combainedFilter.homepageFirstPage = this.homepageFirstPage;
        combainedFilter.filtMinLength = this.filtMinLength != null ? this.filtMinLength : generalFilter.filtMinLength;
        combainedFilter.filtMaxLength = this.filtMaxLength != null ? this.filtMaxLength : generalFilter.filtMaxLength;
        combainedFilter.filtRabbis = this.filtRabbis.length > 0 ? this.filtRabbis : generalFilter.filtRabbis;
        combainedFilter.orderBy = this.orderBy !== null ? this.orderBy : generalFilter.orderBy;
        combainedFilter.order = this.order !== null ? this.order : generalFilter.order;
        combainedFilter.searchTerm = this.searchTerm ? this.searchTerm : generalFilter.searchTerm;
        combainedFilter.page = this.page !== null ? this.page : generalFilter.page;

        return combainedFilter;
    }

    public unFilt() {
        this.unFiltFormat();
        this.unfiltLength();
        this.unFiltContentType();
        this.catId = null;
        this.filtRabbis = [];
    }

    public unFiltFormat() {
        this.filtTxt = false;
        this.filtPDF = false;
        this.filtDoc = false;
        this.filtVideo = false;
        this.filtAudio = false;
    }
    public unFiltContentType() {
        this.filtChildLesson = false;
        this.filtGeneralLesson = false;
        this.filtWomanLesson = false;
    }
    public unfiltLength() {
        this.filtMinLength = undefined;
        this.filtMaxLength = undefined;
    }

    public filtRead(inFilter: Boolean): void {
        this.filtTxt = inFilter;
        this.filtPDF = inFilter;
        this.filtDoc = inFilter;
    }

    public filtMedia(inFilter: Boolean) {
        this.filtVideo = inFilter;
        this.filtAudio = inFilter;
    }

    public isEqualArreys(arr1: any[], arr2: any[]): boolean {
        return arr1.length == arr2.length && arr1.every((val, index) => arr2.indexOf(val) >= 0);
    }

    public isFormatFilt(): Boolean {
        if (this.filtVideo || this.filtAudio || this.filtPDF || this.filtTxt || this.filtDoc) {
            return true;
        }
        return false;
    }
}
